// extracted by mini-css-extract-plugin
module.exports = {"policies":"policies___1IVrO","policy":"policy___vBzLV","title":"title___3mkH8","pre":"pre___ZMPJV","empty":"empty___20Pxo","block":"block___3WYda"};